import { OnInit } from "@angular/core";
import { BpgCommonService } from "../../bpg-common/services/bpg-common.service";
import { BpgEventsService } from "../../bpg-events/bpg-events.service";
import { HoshinBudgetService } from "../hoshin-budget.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ConstantValues } from "../../bpg-common/models/bpg-constants";
import { encodePlanContext } from "../../annual-plan/utils/annual-plan-context.util";
import { EnvironmentConfiguration } from "src/app/environment/services/environment.configuration";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var HoshinHomeComponent = /** @class */ (function () {
    function HoshinHomeComponent(bpgCommonService, bpgEventsService, hoshinBudgetService, router, spinnerService, environment) {
        this.bpgCommonService = bpgCommonService;
        this.bpgEventsService = bpgEventsService;
        this.hoshinBudgetService = hoshinBudgetService;
        this.router = router;
        this.spinnerService = spinnerService;
        this.environment = environment;
        this.budgetList = [];
        this.loginData = JSON.parse(localStorage.getItem("loginData"));
        this.userId = this.loginData.userId;
        this.adminId = localStorage.getItem("adminId");
        this.chapterId = "";
        this.chapterIds = [];
        this.today = new Date();
        this.currentPage = 0;
        this.limit = ConstantValues.pageLimit;
        this.totalPages = 0;
        this.currentShowingElements = ConstantValues.pageLimit;
        this.fyList = [];
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.isbpgAdmin = false;
        this.isbpgLeadAdmin = false;
        this.isNaacAdmin = false;
        this.selectAllConstant = 'Select All';
        this.fiscalYear = '';
        this.fyDropdownList = [];
    }
    HoshinHomeComponent.prototype.encodedPlanContext = function (siteId, bpgId) {
        return encodePlanContext({ siteId: Number(siteId), bpgId: Number(bpgId), fiscalYear: Number(this.fiscalYear) });
    };
    HoshinHomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.environment.envName === "dev" ||
            this.environment.envName === "qa" ||
            this.environment.envName === "prod") {
            if (localStorage.getItem("loginData") === null ||
                localStorage.getItem("loginData") === undefined) {
                this.router.navigate(["/log-out"]);
            }
        }
        if (localStorage.getItem("logOutFlag") === "true") {
            this.router.navigate(["/log-out"]);
        }
        this.userAndRoleIdDTO = {
            userId: this.loginData["userId"],
            roleId: localStorage.getItem("adminId"),
        };
        this.spinnerService.show();
        if (localStorage.getItem("isbpgAdmin") === "true") {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem("isbpgLeadAdmin") === "true") {
            this.isbpgLeadAdmin = true;
        }
        if (localStorage.getItem("isNaacAdmin") === "true") {
            this.isNaacAdmin = true;
        }
        if (this.adminId !== "1" &&
            this.adminId !== "2" &&
            this.adminId !== "3" &&
            this.adminId !== "4" &&
            !this.isbpgAdmin &&
            !this.isbpgLeadAdmin &&
            !this.isNaacAdmin) {
            this.router.navigate(["/site-home"]);
        }
        this.spinnerService.show();
        this.logUserAction();
        this.statusList = [{ status: this.selectAllConstant }, { status: "NEW" }, { status: "DRAFT" }, { status: "SUBMITTED" }, { status: "APPROVED" }, { status: "NOT APPROVED" }];
        this.tableShow = false;
        this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(function (data) {
            _this.chapterList = data;
            _this.chapterList.map(function (i) {
                i.siteName = i.siteName + "-" + i.bpgName;
                return i;
            });
            for (var i = 0; i < _this.chapterList.length; i++) {
                if (i === _this.chapterList.length - 1) {
                    _this.chapterId = _this.chapterId + _this.chapterList[i].chapterId;
                }
                else {
                    _this.chapterId =
                        "" + _this.chapterId + _this.chapterList[i].chapterId + ",";
                }
            }
            _this.siteData = {
                filter: {
                    chapterId: _this.chapterId,
                },
                moduleId: 0,
                page: 0,
                presentRole: "",
                searchTerm: "",
                size: 0,
                sortDirection: "DESC",
                sortProperty: "fiscal_year",
                uid: "",
            };
            _this.bpgCommonService.getSiteList(_this.siteData).subscribe(function (data) {
                _this.siteList = data;
                //filter default site from sitelist
                _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== "DFLT"; });
                _this.siteList.unshift({
                    siteId: 0,
                    siteName: _this.selectAllConstant,
                    bpgName: "",
                });
                for (var i = 0; i < _this.siteList.length; i++) {
                    if (i === 0) {
                        _this.allSiteIds = _this.siteList[i].siteId;
                    }
                    else {
                        _this.allSiteIds = "" + _this.allSiteIds + _this.siteList[i].siteId + ",";
                    }
                }
                _this.siteChange(0);
            });
            _this.chapterList.unshift({
                chapterId: _this.chapterId,
                siteName: _this.selectAllConstant,
                bpgName: "",
            });
            _this.landingData = {
                filter: { chapterId: _this.chapterId, fiscalYear: _this.fiscalYear },
                moduleId: 0,
                page: 0,
                presentRole: "",
                searchTerm: "",
                size: ConstantValues.pageLimit,
                sortDirection: "DESC",
                sortProperty: null,
                uid: "",
            };
            _this.spinnerService.show();
            _this.landingData.sortProperty = 'site_id';
            _this.getChaptersList();
        }, function (err) {
            _this.spinnerService.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
        if (window.innerWidth < 767) {
            this.tableresp = true;
        }
        else {
            this.tableresp = false;
        }
        var year = new Date().getFullYear();
        var month = new Date().getMonth() + 1;
        var currentFiscalYear;
        // If the month is before April, the fiscal year is the previous year
        if (month < 4) {
            currentFiscalYear = year;
            this.fyList = [String(currentFiscalYear + 1), String(currentFiscalYear), String(currentFiscalYear - 1)];
        }
        else {
            currentFiscalYear = year + 1;
            this.fyList = [String(currentFiscalYear + 1), String(currentFiscalYear), String(currentFiscalYear - 1)];
        }
        this.fyDropdownList = this.fyList.map(function (fy) { return ({
            fiscal: "FY" + fy.slice(-2),
            fiscalYear: String(fy)
        }); });
        this.fiscalYear = String(currentFiscalYear);
    };
    HoshinHomeComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.userId,
            categoryDescription: "Annual Plan Home"
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    /** For getting all budget data
     * @class HoshinListingComponent
     * @method getBudgetList
     */
    HoshinHomeComponent.prototype.getChaptersList = function () {
        var _this = this;
        this.timeOutError = false;
        this.spinnerService.show();
        this.hoshinBudgetService.getHoshinChapterListing(this.landingData).subscribe(function (data) {
            _this.tableShow = true;
            _this.chaptersData = data.content;
            _this.numberOfElements = data.totalElements;
            _this.spinnerService.hide();
            if (_this.chaptersData.length === 0) {
                _this.tableShow = false;
                _this.noDataFound = true;
            }
            else {
                _this.tableShow = true;
                _this.noDataFound = false;
                _this.spinnerService.hide();
            }
        }, function (err) {
            _this.spinnerService.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    /** For filtering data by current page
     * @class HoshinListingComponent
     * @method pageChanged
     * @params event
     */
    HoshinHomeComponent.prototype.pageChanged = function (event) {
        this.landingData.page = event - 1;
        this.currentPage = event;
        if (this.currentPage * this.limit < this.numberOfElements) {
            this.currentShowingElements = this.currentPage * this.limit;
        }
        else if (this.currentPage * this.limit > this.numberOfElements) {
            this.currentShowingElements = this.numberOfElements;
        }
        this.getChaptersList();
    };
    /** For searching the table through keywords
     * @class HoshinListingComponent
     * @method searchChapter
     */
    HoshinHomeComponent.prototype.searchChapter = function () {
        var _this = this;
        this.timeOutError = false;
        this.selectedSiteId = this.siteId;
        this.selectedErgId = this.bpgId;
        this.selectedSiteId = this.selectedSiteId ? this.selectedSiteId : null;
        this.selectedErgId = this.selectedErgId ? this.selectedErgId : null;
        if (this.selectedErgId === 0 || this.selectedErgId === null) {
            this.selectedErgId = null;
        }
        if (this.selectedSiteId === 0 || this.selectedSiteId === null) {
            this.selectedSiteId = null;
        }
        this.landingData = {
            filter: {
                siteId: this.selectedSiteId,
                bpgId: this.selectedErgId,
                userId: this.userId,
                adminId: this.adminId,
                hoshinStatus: this.selectedStatus == this.selectAllConstant ? null : this.selectedStatus,
                fiscalYear: this.fiscalYear
            },
            moduleId: 0,
            page: 0,
            presentRole: "",
            searchTerm: "",
            size: ConstantValues.pageLimit,
            sortDirection: "DESC",
            sortProperty: "site_id",
            uid: "1",
        };
        this.hoshinBudgetService.getHoshinChapterListing(this.landingData).subscribe(function (data) {
            _this.tableShow = true;
            _this.chaptersData = data.content;
            _this.numberOfElements = data.totalElements;
            _this.currentShowingElements = ConstantValues.pageLimit;
            _this.currentPage = 1;
            if (_this.chaptersData.length === 0) {
                _this.tableShow = false;
                _this.noDataFound = true;
            }
            else {
                _this.tableShow = true;
                _this.noDataFound = false;
            }
        }, function (err) {
            _this.spinnerService.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    HoshinHomeComponent.prototype.viewMoreHoshinDetails = function (data) {
        sessionStorage.setItem("bpgIdForHoshin", JSON.stringify(data.bpgId));
        sessionStorage.setItem("siteIdForHoshin", JSON.stringify(data.siteId));
        sessionStorage.setItem("fiscalYear", (this.fiscalYear));
        this.router.navigate(["/annual-plan"]);
    };
    Object.defineProperty(HoshinHomeComponent.prototype, "isAnnualPlanV2Year", {
        get: function () {
            // Kept local so this eager component never imports the lazy annual-plan module.
            return !!this.environment.features.annualPlanV2 && Number(this.fiscalYear) >= 2027;
        },
        enumerable: true,
        configurable: true
    });
    /** For site change from site list
     * @class ExpenseClaimListComponent
     * @method siteChange
     * @returns Promise
     */
    HoshinHomeComponent.prototype.siteChange = function (event) {
        var _this = this;
        this.bpgList = [];
        this.selectedErgId = null;
        this.bpgValue = null;
        this.bpgId = null;
        if (event !== undefined) {
            this.selectedSiteId = event.siteId;
        }
        else {
            this.selectedSiteId = 0;
            this.selectedSiteId = null;
        }
        this.selectedBpgsData = {
            filter: {
                siteId: this.selectedSiteId,
                userId: this.userAndRoleIdDTO.userId,
                adminId: this.userAndRoleIdDTO.roleId,
            },
            moduleId: 0,
            page: 0,
            presentRole: "string",
            searchTerm: "string",
            size: 0,
            sortDirection: "ASC",
            sortProperty: "string",
            uid: "string",
        };
        this.bpgCommonService
            .getMyBPGsList(this.selectedBpgsData)
            .subscribe(function (data) {
            _this.bpgList = data;
            if (_this.bpgList.length > 1) {
                _this.bpgList.unshift({ bpgId: 0, bpgName: _this.selectAllConstant });
            }
            for (var i = 0; i < _this.bpgList.length; i++) {
                if (i === 0) {
                    _this.allBpgIds = _this.bpgList[i].bpgId;
                }
                else {
                    _this.allBpgIds = "" + _this.allBpgIds + _this.bpgList[i].bpgId + ",";
                }
            }
        });
    };
    /** For bpg change from bpg list
     * @class ExpenseClaimListComponent
     * @method bpgChange
     * @returns Promise
     */
    HoshinHomeComponent.prototype.bpgChange = function (event) {
        if (event !== undefined) {
            this.selectedErgId = event.bpgId;
        }
        else {
            this.selectedErgId = null;
        }
    };
    HoshinHomeComponent.prototype.changeStatus = function (event) {
        if (event !== undefined) {
            if (event.status === "NOT APPROVED") {
                this.selectedStatus = "REJECTED";
            }
            else {
                this.selectedStatus = event.status;
            }
        }
        else {
            this.selectedStatus = null;
        }
    };
    HoshinHomeComponent.prototype.changeFy = function (selectedFy) {
        this.fiscalYear = selectedFy.fiscalYear;
        if (selectedFy !== undefined) {
            this.selectedFy = selectedFy.fiscalYear;
        }
        else {
            this.selectedFy = null;
        }
    };
    return HoshinHomeComponent;
}());
export { HoshinHomeComponent };
